import React, { useEffect, useState } from 'react'
import { useCourseSettings } from 'src/hooks/useCourseSettings'
import { withStyles } from '@material-ui/core'
import styles from 'src/components/editor/components/ck-editor/styles'
import { useSelector } from 'react-redux'

const LandingPagePreview = props => {
  const {
    classes,
    fontFamily,
    fontSize,
    pageUrl,
    customHtmlContent,
    theme,
  } = props
  const { value } = useCourseSettings('general')
  const [editorData, setEditorData] = useState(null)
  const landingPageData = useSelector(state => state.course.landingPageSettings)
  const landingPageDataCollection = useSelector(
    state => state.collection.landingPageSettings,
  )
  useEffect(() => {
    if (value?.coverPageText) {
      setEditorData(value.coverPageText)
    }
  }, [value])

  // Determine the content to display
  const getContentToDisplay = () => {
    // First priority: use customHtmlContent if it exists and isn't empty
    if (customHtmlContent && customHtmlContent !== '') {
      return customHtmlContent
    }

    // Second priority: use appropriate landing page data based on pageUrl
    if (pageUrl === 'mini-course') {
      return landingPageData?.sections?.[1]?.content?.html || ''
    } else {
      return landingPageDataCollection?.sections?.[1]?.content?.html || ''
    }
  }
  return (
    <div className={classes.ckEditorFont}>
      <div
        fontSize={fontSize}
        fontFamily={fontFamily}
        theme={theme}
        id="ck-editor-font"
        dangerouslySetInnerHTML={{
          __html: getContentToDisplay(),
        }}
      />
    </div>
  )
}

export default withStyles(styles)(LandingPagePreview)
